import React, { useEffect, useState } from 'react';
import api from '../../api/index.js'; // Importando a instância do axios configurada

import styles from './Header.module.css';

import Logo from '../../assets/img/Globe-256.png';

import moment from 'moment-timezone';

/* contexts */
import { Context } from '../../context/UserContext';
import { useContext } from 'react';

import { getFrontVersionLabel } from '../../utils/appVersion';
import { getServerVersion } from '../../utils/serverVersion';

const caminho = process.env.REACT_APP_API ? process.env.REACT_APP_API.replace(/\/$/, '') : '/api';

function Header() {
    const { authenticated, parametro } = useContext(Context);
    const [backendVersion, setBackendVersion] = useState('');
    const [backendBanco, setBackendBanco] = useState('');

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                const serverInfo = await getServerVersion();

                setBackendVersion(serverInfo.versaoBack);
                setBackendBanco(serverInfo.banco);
            } catch (error) {
                console.error('Erro ao obter a versão do backend', error);
            }
        };

        fetchVersion();
    }, []); // Executa apenas uma vez durante o montagem do componente

    return (
        <header>
            <div className={styles.header_logo}>
                <a href="/" title="Home">
                    <img
                        src={
                            localStorage.getItem('logomarca')
                                ? `${caminho}/imagens/${localStorage.getItem('logomarca').replace(/["]/g, '')}`
                                : Logo
                        }
                        alt="Logomarca da empresa"
                        width={parametro?.logomarcaLargura || 80}
                        height={parametro?.logomarcaAltura || 80}
                    />
                </a>

                <h2>{localStorage.getItem('nomeFantasia') && `${localStorage.getItem('nomeFantasia').replace(/["]/g, '')}`}</h2>
            </div>
            <div className={`User ${authenticated ? 'Logado' : 'NaoLogado'}`}>
                <p style={{ fontSize: '12px' }}>Cliente: {getFrontVersionLabel()}</p>
                <p style={{ fontSize: '12px' }}>Servidor: {backendVersion}</p>
                <p style={{ fontSize: '12px' }}>Banco: {backendBanco}</p>
                <h4>Olá: {localStorage.getItem('nome')?.replace(/["]/g, '') || 'visitante'} </h4>
            </div>
        </header>
    );
}

export default Header;
